export const FY_CHANNEL = [
  { label: '中信百信银行', value: '01' },
  { label: '福建华通银行', value: '10' },
  { label: '江苏苏商银行', value: '12' }
] as const;
